<template>
    <!-- Componente para mostrar el detalle de un modelo con sus correspondientes -->
    <!-- highlights en la sección de todos los modelos -->
    <div class="relative model-detail w-11/12 bg-light-brown px-5 lg:px-12 mt-8 pt-20 pb-10 lg:py-8">
        <div
            class="model-triangle w-0 h-0 border-solid absolute -mt-24 lg:-mt-12"
            style="border-width: 4px 13.5px 13px 13.5px; border-color: transparent transparent #f7f3f2 transparent"
            :style="{ 'margin-left': modelPosition ? `calc(${modelPosition}px + 30px)` : '' }"
        ></div>
        <img
            class="w-3 absolute top-0 right-0 mt-4 mr-4 cursor-pointer"
            :src="url + '/images/close_icon.png'"
            alt="Cerrar"
            @click="closeModelDetail()"
        />
        <div class="lg:flex lg:justify-between">
            <div class="lg:w-1/2">
                <img
                    class="w-11/12 mx-auto lg:mx-0 sm:w-8/12 mb-4 lg:mt-12 lg:w-9/12"
                    :src="model.model_image"
                    :alt="model.name"
                />
                <p class="text-xs md:text-sm mt-6 text-justify sm:w-8/12 mb-1 lg:mt-12 lg:w-9/12">
                    *Las imágenes son únicamente de referencia, algunas versiones no se encuentran disponibles en México o pueden cambiar según la versión. <br/>Consulta nivel de equipamiento y disponibilidad por versión en tu Distribuidor Autorizado Hyundai.
                </p>
                <a
                    class="hidden lg:block w-40 text-center text-sm bg-dark-blue text-white py-2 mt-16"
                    :href="`${url}/${webpage}/modelos/configura-una-version/${getModelUrl(model.slug)}/${getPTUrl(trimId)}/${model.year}${activeCategory == 'especiales' ? '?type=especial' : ''}`"
                >
                    Ver más
                </a>
            </div>
            <div class="lg:w-2/3 flex flex-col gap-5">
                <fieldset>
                    <label class="block font-bold mb-3 text-sm" for="version">Elije una versión</label>
                    <select
                        class="w-full h-10 text-sm px-6 appearance-none bg-no-repeat bg-white"
                        :style="{
                            'background-image': `url('${url}/images/select_arrow.png')`,
                            'background-size': '0.6rem',
                            'background-position': '96.5%',
                        }"
                        name="version"
                        id="version"
                        v-model="trimId"
                    >
                        <option
                            v-for="powerTrain in model.power_trains"
                            :key="powerTrain.id"
                            :value="powerTrain.display_name"
                        >
                            {{ powerTrain.name }}
                        </option>
                    </select>
                </fieldset>
                <div class="">
                    <h3 class="font-bold text-sm mb-3">Desde</h3>
                    <div class="bg-white px-6 py-2">{{ formattedPrice }}</div>
                </div>
                <div class="">
                    <h3 class="font-bold text-sm mb-3">Información general</h3>
                    <table class="text-left text-sm w-full">
                        <tr
                            v-for="(trimHighlight, index) in trimHighlights"
                            :key="index"
                            class="h-10 border-b-2 border-light-brown border-solid"
                        >
                            <!-- <td class="pl-6 sm:pl-10 bg-brown font-bold">Categoría</td> -->
                            <td class="px-6 py-2 bg-white font-bold leading-tight flex items-center">
                                <div class="w-12 mr-4" v-html="trimHighlight.svg"></div>
                                <p>{{ trimHighlight.highlight }}</p>
                            </td>
                        </tr>
                        <!-- <tr class="h-10 border-b-2 border-light-brown border-solid">
                            <td class="pl-6 sm:pl-10 bg-brown font-bold">Etiqueta de Producto</td>
                            <td class="pl-6 sm:pl-10 bg-white">Gamma 1.6 GDi 6 Speed Manuel FF 2WD</td>
                        </tr>
                        <tr class="h-10 border-b-2 border-light-brown border-solid">
                            <td class="pl-6 sm:pl-10 bg-brown font-bold">Modelo</td>
                            <td class="pl-6 sm:pl-10 bg-white">Accent</td>
                        </tr>
                        <tr class="h-10 border-b-2 border-light-brown border-solid">
                            <td class="pl-6 sm:pl-10 bg-brown font-bold">Asientos</td>
                            <td class="pl-6 sm:pl-10 bg-white">5</td>
                        </tr> -->
                    </table>
                </div>
                <a
                    class="block lg:hidden w-40 text-center text-sm bg-dark-blue text-white py-2 mx-auto"
                    :href="`${url}/${webpage}/modelos/configura-una-version/${getModelUrl(model.slug)}/${getPTUrl(trimId)}/${model.year}`"
                >
                    Ver más
                </a>
            </div>
        </div>
    </div>
</template>

<script>
const mexicanPesoFormatter = new Intl.NumberFormat("es-mx", {
    style: "currency",
    currency: "MXN",
    maximumFractionDigits: 0,
});
export default {
    props: ["model", "activeCategory"],
    data() {
        return {
            url: $(".url").text(),
            webpage: $(".webpage").text(),
            // Variable para almacenar las versiones del modelo
            // seleccionado
            modelTrims: [],
            // Variable para almacenar el id de la versión seleccionada
            trimId: null,
        };
    },
    watch: {
        model: function (model) {
            this.trimId = model.power_trains[0].display_name;
        },
    },
    methods: {
        capitalize(string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        },
        // Función para cerrar el modal del detalle del modelo
        closeModelDetail() {
            this.$emit("close-model-detail");
        },
        // Función para obtener la url del modelo
        getModelUrl(modelSlug) {
            return modelSlug ? modelSlug.replaceAll("_", "-") : "";
        },
        getPTUrl(displayName) {
            return displayName ? displayName.replaceAll(" ", "-") : "";
        },
    },
    computed: {
        // Retorna la distancia del modelo seleccionado
        // respecto a la parte izquierda del div contenedor
        modelPosition() {
            return this.model.id ? $("#model-" + this.model.id).offset().left - $(".models").offset().left : 0;
        },
        // Determina si existen los highlights del modelo
        // seleccionado para mostrarlos en el detalle del modelo
        trimHighlights() {
            let powerTrain = this.model.power_trains
                ? this.model.power_trains.find((powerTrain) => powerTrain.display_name === this.trimId)
                : null;
            return powerTrain ? powerTrain.highlights : [];
        },

        selectedVehicle() {
            if (this.model.power_trains) {
                return this.model.power_trains.find((powerTrain) => powerTrain.display_name === this.trimId);
            }
            return null;
        },

        formattedPrice() {
            if (!this.selectedVehicle?.price) {
                return "No disponible";
            }
            return `${mexicanPesoFormatter.format(this.selectedVehicle?.price)} MXN`;
        },
    },
};
</script>
